<template style="backgroundColor:#fbfff5">
  <div id="app">
    <!-- 顶部 -->
    <div class="header">
      <div></div>
      <div class="centerLogo">
        <img class="topLogo" src="../static/image/logo.png" alt="深大文德" />
        <div class="tittle">少年公社</div>
      </div>
      <div class="appDownload">
        <router-link to='../appData'>

        <div class="downloadText">点击下载美德少年APP</div>
        </router-link>

      </div>
      <div class="login">
      <router-link to="../login/login">登录</router-link>

      </div>
    </div>

    <!-- 导航菜单 -->
    <el-menu
      :default-active="this.$route.path"
      router
      mode="horizontal"
      class="el-menu-demo"
      @select="handleSelect"
      background-color="#FBFFF5"
      text-color="#808080"
      active-text-color="#E50112"
    >
      <el-menu-item v-for="(item, i) in navList" :key="i" :index="item.name">
        <template slot="title">
          <span> {{ item.navItem }}</span>
        </template>
      </el-menu-item>
    </el-menu>

    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",

  data() {
    return {
      navList: [
        { name: "/", navItem: "首页" },
        { name: "/roleDisplay", navItem: "角色展示" },
        { name: "/newsCenter", navItem: "新闻中心" },
        { name: "/cultureZone", navItem: "文化专区" },
        { name: "/appData", navItem: "APP资料" },
        { name: "/playerInteraction", navItem: "隐私条款" },
        { name: "/callCenter", navItem: "客服中心" }
      ]
    };
  },

  methods: {
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    }
  },

};
</script>

<style scoped>
body {
  background-color: #fbfff5;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  margin: 0 18%;
  background-color: #fbfff5;

}
.centerLogo {
  width: 25%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  left: 10%;
}
.topLogo {
  width: 20%;
  height: 20%;
  margin-right: 2%;
}

.tittle {
  font-weight: bold;
  color: #e50112;
  font-size: 22px;
}

.header {
  color: #333;
  text-align: center;
  /* line-height: 20px; */
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.appDownload {
  width: 30%;
  height: 70%;
  border: #89c33f 1px solid;
  border-radius: 10px;
  padding: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;

}
.downloadText {
  font-size: 14px;
  font-weight: bold;
  color: #89c33f;

}
.downloadImg {
  width: 30%;
  height: 86%;
}
.phoneType {
  margin: 5px 10px;
  font-size: 20px;
  display: flex;
}
.el-icon-download {
  color: #89c33f;
}
.iph {
  color: #f1ae04;
}
.appstore {
  text-decoration: none;
  color: #f1ae04;
  border: #f1ae04 1px solid;
  border-radius: 6px;
  margin-bottom: 5px;
}
.andriod {
  text-decoration: none;
  color: #3FB9E9;
  border: #3FB9E9 1px solid;
  border-radius: 6px;
}

.login {
  font-size: 20px;
}

@media screen and (max-width: 700px) {
  #app {
    margin: 0;
  }
  .appDownload {
    width: 26%;
    height: 70%;
  }
  .centerLogo {
    width: 40%;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue